import { Box } from "../../ui/box";

/** A static, illustrative upward trend — not a chart of anything. The point is "we
 * are crunching numbers", not a number itself, which is why nothing here is
 * derived from real pricing data. `strokeDasharray`/`420` is generous on purpose:
 * the path is well under that length, so `draw` always finishes fully drawn.
 *
 * Raw DOM `<svg>`/`<polyline>`, not `react-native-svg`: this card only ever
 * renders on web (the agent kit is center-only today), and `react-native-svg`'s
 * web types carry no `className`, which is what `animate-draw`/`stroke-brand-500`
 * need to reach it — `apps/center/.../analytics/report/shared/sparkline.tsx` is
 * the same call for the same reason. */
const SPARK_POINTS = "0,34 14,27 28,30 42,15 56,20 70,7 84,13 98,3";

const PricingSparkline = ({ active }: { active: boolean }) => (
  <Box className="mt-3 w-full">
    <svg viewBox="0 0 100 36" width="100%" height={36}>
      <polyline
        points={SPARK_POINTS}
        fill="none"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray={420}
        className={`stroke-brand-500 ${active ? "animate-draw motion-reduce:animate-none" : ""}`}
      />
    </svg>
  </Box>
);

export default PricingSparkline;
